<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="60%"
    @open="handleOpen"
    append-to-body
    :before-close="handleClose"
  >
    <span style="display: inline-block; margin: 0px 0 10px">
      <span>账号：</span>
      <el-select
        v-model="account"
        size="small"
        clearable
        multiple
        @change="onAccountChange"
        placeholder="选择账号"
        style="width: 200px; margin-right: 10px"
      >
        <el-option
          v-for="item in accountOptions"
          :key="item.id"
          :label="item.account"
          :value="item.accountId"
        >
        </el-option>
      </el-select>
      <span>打招呼模版：</span>
      <el-select
        v-model="modelName"
        size="small"
        clearable
        @change="onModelChange"
        placeholder="选择打招呼模版"
        style="width: 200px; margin-right: 10px"
      >
        <el-option
          v-for="item in options"
          :key="item.id"
          :label="item.groupName"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span>间隔时间(分钟)：</span>
      <el-input
        v-model="intervalTime"
        type="number"
        :min="1"
        @input="handleInput"
        style="width: 200px"
        placeholder="输入打招呼间隔时间"
      ></el-input>
    </span>
    <el-card>
      <el-table :data="exceldata" border max-height="400px" style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="150"
        ></el-table-column>
        <el-table-column
          v-if="type == 'userName'"
          prop="userName"
          label="用户名"
        ></el-table-column>
        <el-table-column
          v-else-if="type == 'phoneNumber'"
          prop="phoneNumber"
          label="手机号"
        ></el-table-column>
        <el-table-column
          v-else-if="type == 'account'"
          prop="account"
          label="发送方(账号)"
        ></el-table-column>
        <el-table-column
          v-if="type == 'account'"
          prop="targetUser"
          label="接收方(账号)"
        ></el-table-column>
        <el-table-column prop="hellostring" label="打招呼语"></el-table-column>
      </el-table>
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" @click="handleSubmit"
        >提交</el-button
      >
      <el-button size="small" @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "批量上传",
    },
    exceldata: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      uid: "",
      options: [],
      modelName: "",
      intervalTime: "",
      account: "",
    };
  },
  computed: {
    accountOptions() {
      const list = this.$store.state.cicadeStore.accounts.filter((account) => {
        return account.status === 1;
      });
      return list || [];
    },
  },
  methods: {
    handleInput(value) {
      if(value){
        const integerValue = Math.floor(value);
        this.intervalTime = integerValue;
      }else{
        this.intervalTime = 1;
      }
    },
    // 获取打招呼模版
    getGreetList() {
      this.$http.get("/client/greet").then((res) => {
        this.options = res;
      });
    },

    onModelChange(e) {
      const object = this.options.find((item) => {
        return item.id == e;
      });
      this.exceldata.forEach((item) => {
        if (object) {
          const randomIndex = Math.floor(
            Math.random() * object.greetInfoList.length
          );
          item.hellostring = object.greetInfoList[randomIndex].content;
        }
      });
    },
    onAccountChange(e) {
      if (e.length > 0) {
        let index = 0;
        this.exceldata.forEach((item) => {
          this.$set(item, "accountId", e[index]);
          this.$set(item, "account", this.filterAccount(e[index]));
          index = (index + 1) % e.length;
        });
      } else {
        this.exceldata.forEach((item) => {
          this.$set(item, "accountId", undefined);
          this.$set(item, "account", undefined);
        });
      }
    },
    filterAccount(accountId) {
      return this.accountOptions.find((item) => {
        return item.accountId == accountId;
      }).account;
    },
    handleClose() {
      this.$emit("close");
    },
    handleOpen() {
      this.uid = Date.now();
      this.getGreetList();
      this.modelName = "";
      this.intervalTime = "";
      this.account = "";
    },
    getRandomThreeDigit() {
      return Math.floor(Math.random() * 900) + 100;
    },
    getGreetArr(arr) {
      if (!Array.isArray(arr)) return [];
      return arr.map((item) => {
        let newItem = { ...item };
        if ("phoneNumber" in newItem) {
          newItem.targetUser = newItem.phoneNumber;
          delete newItem.phoneNumber;
        } else if ("userName" in newItem) {
          newItem.targetUser = newItem.userName;
          delete newItem.userName;
        }
        return newItem;
      });
    },
    handleSubmit() {
      this.$confirm("此操作将提交该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            uid: this.uid + this.getRandomThreeDigit().toString(),
            greetType: this.type,
            intervalTime: this.intervalTime,
            channelName:
              this.$store.state.cicadeStore.activeChannel.channelName,
            greetInfos: this.getGreetArr(this.exceldata),
          };
          this.$http.post("/client/greetPoly", params).then((res) => {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.handleClose();
            this.$emit("getList");
          });
        })
        .catch(() => {});
    },
  },
};
</script>
